import React from 'react';
import styled from 'styled-components';
import Button from '../Button';
import { Link } from '../Link/styles';
import alertImg from '../../static/img/alerta.svg';

const InternalServerErrorContainer = styled.div`
  width: 300px;
  height: 53vh;
  display: flex;
  flex-direction: column;
  justify-content: center;

  > div {
    margin-top: 10px;
    > span {
      font-size: 12px;
      color: #666666;
      > a {
        font-weight: bold;
      }
    }
    > .title-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
    }
    > h1 {
      margin: 0;
    }
    > p {
      margin-top: 24px;
      margin-bottom: 30px;
      font-size: 14px;
    }

    img {
      width: 84px;
      height: 84px;
    }
  }

  @media (max-width: 650px) {
    width: 90%;
  }
`;

const InternalError = () => {
  return (
    <InternalServerErrorContainer>
      <div>
        <div className="title-wrapper">
          <img src={alertImg} alt="alerta" />
          <h1>Algo deu errado</h1>
        </div>
        <p>
          Ocorreu um erro e não foi possível completar essa ação. Por favor,
          tente novamente.
        </p>
      </div>

      <Button
        onClick={() => window.location.reload()}
        width="100%"
        variant="primary"
      >
        Tentar novamente
      </Button>
      <div>
        <span>
          Continua com problema?{' '}
          <Link href="https://ajuda.globo.com" target="_blank" rel="noreferrer">
            CENTRAL DE AJUDA
          </Link>
        </span>
      </div>
    </InternalServerErrorContainer>
  );
};

export default InternalError;
